import React, { Component } from 'react';


export class QASection extends Component {
    render() {
        let qaQuestions = this.props.program.QAQuestions;
        let questionsList = qaQuestions.map((item, index) => {
            return <div key={index}><h3 className="title-bd body-bd pr-3 ">Q:  {item[0]}</h3><p className="body-lt p-2">{item[1]}</p></div>
        })

        return (
            <section id="QA-section">
                <div className="p-5 bg-color-theme-2 mb-4">
                    <div className="mt-3 mb-3 pb-2">
                        <h2 className="title-bd">Q &amp; A Section</h2>
                    </div>
                    <div id="Question-list">
                        {questionsList}
                    </div>
                </div>
            </section>
        );
    }
}